import toast from "react-hot-toast";
import { GrFormClose } from "react-icons/gr";
import { PiWarningCircleFill } from "react-icons/pi";
 
 
export default function ToastMessage(status, text) {
 
  const isSmallScreen = window.innerWidth <= 767;
 
  if (status === 1) {
    toast.success(text);
  } else if (status === 0) {
    // toast.error(text);
    toast.custom((t) => (
      <div
      className={`${t.visible ? "animate-custom-enter" : "animate-custom-leave "}
      max-w-sm bg-danger shadow-lg rounded-lg pointer-events-auto flex border-l-4 border-red-500 me-lg-5 me-2`}
      style={{width: 'auto'}}
    >
      {/* Left Icon */}
      <div className="flex items-center justify-center p-3 pe-0 bg-danger ">
        <PiWarningCircleFill className="text-red-500 text-2xl" style={{fontSize: "18px"}} />
      </div>
 
      {/* Message */}
      <div className="flex-1 py-3 px-2 px-lg-3 text-gray-800 text-sm font-medium text-nowrap bg-danger ">
        {text}
      </div>
 
      {/* Close Button */}
      {/* <div className="flex px-3 cursor-pointer bg-danger">
        <GrFormClose
          className="text-gray-500 text-xl hover:text-gray-700"
          onClick={() => toast.dismiss(t.id)}
        />
      </div> */}
    </div>
    ))
  } else if (status === 2) {
    toast.error(text);
  }
}
 